export default "/ETH.1123bf5b59443c6732441c6a1afaac40.svg";